<template>
	<v-menu
		ref="menu"
		v-model="menu"
		:close-on-content-click="false"
		transition="scale-transition"
		offset-y
		min-width="auto"
		:disabled="readonly"
	>
		<template #activator="{ on, attrs }">
			<v-text-field
				v-bind="{ ...attrs, ...$props }"
				type="date"
				readonly
				v-on="on"
			></v-text-field>
		</template>
		<v-date-picker
			ref="picker"
			v-model="date"
			:min="min"
			:max="max"
			@change="save"
		></v-date-picker>
	</v-menu>
</template>

<script>
export default {
	props: {
		min: [String, Date],
		max: [String, Date],
		readonly: Boolean,
		color: String,
		label: String,
		prependIcon: String,
		clearable: Boolean,
		rules: {
			type: Array,
			default: () => [],
		},
		value: String,
	},

	data: () => ({
		date: null,
		menu: false,
	}),

	methods: {
		save(date) {
			this.$refs.menu.save(date);
			this.$emit("input", date)
		},
	},
};
</script>
